// import React from "react";
// import ReactDOM from "react-dom"; // corrected import
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import "bootstrap/dist/css/bootstrap.min.css";
// import {
//   BrowserRouter as Router,
// } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./state/store.js";
// import { PersistGate } from "redux-persist/integration/react";
// import { persistStore } from "redux-persist";
// import { Suspense } from "react";
// import { Spin } from 'antd';
// import InstallPwaPrompt from "../src/components/beforeinstallPwa.js";
// const persistor = persistStore(store);
// function Loading() {
//   return <Spin />;
// }

// // Catch error event (covers the uncaught error + React overlay in dev)
// window.addEventListener('error', (e) => {
//   if (e.message && e.message.includes('ResizeObserver loop')) {
//     e.stopImmediatePropagation();
//     e.preventDefault();  // Extra: prevents browser console red error in some cases
//   }
// });

// // Patch console.error (covers library warnings)
// const originalError = console.error;
// console.error = (...args) => {
//   if (
//     args.length > 0 &&
//     typeof args[0] === 'string' &&
//     args[0].includes('ResizeObserver loop')
//   ) {
//     return; // Suppress
//   }
//   originalError.apply(console, args);
// };

// ReactDOM.render(
//   <Suspense fallback={<Loading />}>
//     <Provider store={store}>
//       <React.StrictMode>
//         <PersistGate persistor={persistor}>
//           <Router>
//             <InstallPwaPrompt></InstallPwaPrompt>
//             <App />
//           </Router>
//         </PersistGate>
//       </React.StrictMode>
//     </Provider>
//   </Suspense>,
//   document.getElementById("root")
// );

// reportWebVitals();


import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./state/store.js";
import { injectStore } from "./axios-request/API.request"; // NEW
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Suspense } from "react";
import { Spin } from 'antd';
import InstallPwaPrompt from "../src/components/beforeinstallPwa.js";

injectStore(store); // NEW: must run before the first render

const persistor = persistStore(store);
function Loading() {
  return <Spin />;
}

// Catch error event (covers the uncaught error + React overlay in dev)
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Patch console.error (covers library warnings)
const originalError = console.error;
console.error = (...args) => {
  if (
    args.length > 0 &&
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop')
  ) {
    return; // Suppress
  }
  originalError.apply(console, args);
};

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <Provider store={store}>
      <React.StrictMode>
        <PersistGate persistor={persistor}>
          <Router>
            <InstallPwaPrompt></InstallPwaPrompt>
            <App />
          </Router>
        </PersistGate>
      </React.StrictMode>
    </Provider>
  </Suspense>,
  document.getElementById("root")
);

reportWebVitals();